import { render, staticRenderFns } from "./AdminCouponIndexPageTableRow.vue?vue&type=template&id=6fb1b114&"
import script from "./AdminCouponIndexPageTableRow.vue?vue&type=script&lang=ts&"
export * from "./AdminCouponIndexPageTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTd,QIcon});
